/*
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2025, Zumper
 * @description useCarouselExperiment hook
 */

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useContext } from 'react'

const MAX_SLIDE_CHANGES = {
  A: Number.POSITIVE_INFINITY,
  B: 2,
  C: 3,
}

export const useCarouselExperiment = ({ hasEnoughImages }: { hasEnoughImages: boolean }) => {
  const { optimizely } = useContext(OptimizelyContext)

  const activate = () =>
    hasEnoughImages
      ? (optimizely?.activate('WEB_CARD_CAROUSEL_TO_GALLERY') as unknown as 'A' | 'B' | 'C')
      : 'A'
  return {
    activate,
    maxSlideChanges: MAX_SLIDE_CHANGES,
  }
}
